import { UpdateUserSettingsFormData, PatchUserSettingsRequestBody, UserSettings } from "src/types";

export class UserSettingsMapper {
  public static initUpdateUserSettingsFormData(): UpdateUserSettingsFormData {
    return {
      name: "",
      emailGreeting: "",
      purchaseOrderEmailBody: "",
      emailValediction: ""
    };
  }

  public static updateUserSettingsFormDataFromUserSettings(
    name?: string,
    userSettings?: UserSettings
  ): UpdateUserSettingsFormData {
    return {
      name: name ?? "",
      emailGreeting: userSettings?.emailSettings?.emailGreeting ?? "",
      purchaseOrderEmailBody: userSettings?.emailSettings?.purchaseOrderEmailBody ?? "",
      emailValediction: userSettings?.emailSettings?.emailValediction ?? ""
    };
  }

  public static updateUserSettingsRequestBodyFromFormData(
    updateUserSettingsFormData: UpdateUserSettingsFormData
  ): PatchUserSettingsRequestBody {
    return {
      userName: updateUserSettingsFormData.name,
      emailSettings: {
        emailGreeting: updateUserSettingsFormData.emailGreeting,
        purchaseOrderEmailBody: updateUserSettingsFormData.purchaseOrderEmailBody,
        emailValediction: updateUserSettingsFormData.emailValediction
      }
    };
  }
}
